import { render } from "./2.LegalContent.vue?vue&type=template&id=3479586b&scoped=true"
import script from "./2.LegalContent.vue?vue&type=script&lang=js"
export * from "./2.LegalContent.vue?vue&type=script&lang=js"

import "./2.LegalContent.vue?vue&type=style&index=0&id=3479586b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3479586b"]])

export default __exports__